package com.example.monetix.db

import kotlin.Double
import kotlin.Long
import kotlin.String

public data class MerchantLocationEntity(
  public val merchantKey: String,
  public val categoryId: String,
  public val subcategoryText: String?,
  public val latitude: Double,
  public val longitude: Double,
  public val visitCount: Long,
  public val lastVisitedEpochMs: Long,
)
